import React from "react";
import styled from "styled-components";

const StyledBars = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;
  position: absolute;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid ${(props) => props.theme.primaryBlue};
    border-color: ${(props) => props.theme.primaryBlue} transparent
      ${(props) => props.theme.primaryBlue} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const BarLoader = () => {
  return <StyledBars></StyledBars>;
};

export default BarLoader;
